/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */

import get from 'lodash/get';
import {
	createResource,
	type Match,
	type Query,
	type RouteResource,
} from '@atlassian/react-resource-router';
// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
import { ONE_DAY_IN_MILLIS } from './resourceTypeServicedeskQueuesNavigationItems.constants.tsx';
import { getQueueGroupsStateFromUserProperty } from './setQueueGroupsStateInUserProperty.tsx';
import type { State } from './State.types.tsx';

const getProjectKey = ({ match, query }: { match: Match; query: Query }) =>
	// projectKey from url path or browse/{issueKey}
	getProjectKeyId(match, query).projectKey || get(match, 'params.issueKey', '').split('-')[0];

export const nav3QueueGroupsStateResource: RouteResource<State | undefined> = createResource<
	State | undefined
>({
	type: 'SERVICEDESK_NAV3_QUEUE_GROUPS_STATE',
	getKey: getProjectKey,
	getData: async ({ match, query }, { tenantContext: { atlassianAccountId } }) => {
		if (!atlassianAccountId) {
			return undefined;
		}

		const projectKey = getProjectKey({ match, query });
		try {
			return await getQueueGroupsStateFromUserProperty(projectKey, atlassianAccountId);
			// oxlint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireErrorAnalytics({
				error,
				meta: {
					id: 'getQueueGroupsStateInUserPropertyResourceError',
				},
			});
			return undefined;
		}
	},
	maxAge: ONE_DAY_IN_MILLIS,
});
